/* ---
	About page

	<about-read-more> reveals clamped manifesto copy on both desktop and mobile.
--- */

if (typeof AboutReadMore !== 'function') {
  class AboutReadMore extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-about-read-more-toggle]');
      this.label = this.querySelector('[data-about-read-more-label]');
      if (!this.toggle) return;

      this.labelMore = this.toggle.dataset.labelMore || '';
      this.labelLess = this.toggle.dataset.labelLess || this.labelMore;

      this.toggle.addEventListener('click', this.#onToggle.bind(this));
    }

    #onToggle() {
      const isClamped = this.classList.contains('kt-about-manifesto__inner--clamped');
      this.classList.toggle('kt-about-manifesto__inner--clamped', !isClamped);
      this.toggle.setAttribute('aria-expanded', isClamped ? 'true' : 'false');
      if (this.label) {
        this.label.textContent = isClamped ? this.labelLess : this.labelMore;
      }
    }
  }

  customElements.define('about-read-more', AboutReadMore);
}
